import { useCallback, useContext, useMemo } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getEntityAudits } from '@dealstack/frontend/shared/dataExchange/services/audit.service.ts';
import {
	DEAL_ROUTES,
	PEOPLE_ROUTES,
	ROUTES,
} from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { getLatestBasicDetailsAudit } from './basicDetailsHistoryLink.utils.ts';

export const useBasicDetailsHistoryLink = () => {
	const navigate = useNavigate();
	const { selectedEntityId, dealId } = useContext(CapManageControllerContext);
	const personId = selectedEntityId;

	const auditEndpoint = formatUnicorn(API_PATHS.AUDIT_PERSON_PERSONID_GET, {
		personId,
	});

	const { data: audits } = useQuery({
		queryKey: [auditEndpoint, { entityId: personId || '' }],
		queryFn: ({ signal }) => getEntityAudits(auditEndpoint, signal),
		enabled: !!personId,
	});

	const lastBasicDetailsAudit = useMemo(() => getLatestBasicDetailsAudit(audits), [audits]);

	const goToHistory = useCallback(() => {
		if (!personId || !dealId) {
			return;
		}

		navigate(
			generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}${PEOPLE_ROUTES.PERSON_HISTORY}`, {
				dealId,
				personId,
			})
		);
	}, [navigate, dealId, personId]);

	return { lastBasicDetailsAudit, goToHistory };
};
